import { render } from "./CeramsiteFactoryPage.vue?vue&type=template&id=75b2a229&scoped=true"
import script from "./CeramsiteFactoryPage.vue?vue&type=script&lang=js"
export * from "./CeramsiteFactoryPage.vue?vue&type=script&lang=js"

import "@/assets/css/cases.css?vue&type=style&index=0&id=75b2a229&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b2a229"]])

export default __exports__